// @flow
import React, { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useUserData from "../../../../hooks/user/useUserData";
import axios from "axios";
import { API } from "../../../../helpers/constants";
import {
    Grid
} from "@mui/material";

import { LOANS } from "../../locales/namespaces";
import DocumentsList from "../../components/lists/documentsList";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../helpers/errorHandling";
import { mapLoan } from "../../types/map";
import useUserAction from "../../../../hooks/user/useUserAction";

const LoanDetails = ({ loansDocumentsData = [], loanStatus, status = [], loanId }) => {
    const { t } = useTranslation(LOANS)
    const [loading, setLoading] = useState(false)
    const { id } = useParams()
    const [loanDetails, setLoanDetails] = useState({})
    const [loansDocuments, setLoansDocuments] = useState(loansDocumentsData)
    const [loanNotes, setLoanNotes] = useState([])
    const [questionnaire, setQuestionnaire] = useState([])
    const [updateDocuments, setUpdateDocuments] = useState(false)
    const { token, isLoggedIn } = useUserData()
    const { userLogout } = useUserAction()

    const handleUpdateDocuments = (updateDocuments) => setUpdateDocuments(updateDocuments)



    return (
        <Box>
            <Box sx={{}}>
                <Grid>
                    <DocumentsList
                        updateDocuments={updateDocuments}
                        handleUpdateDocuments={handleUpdateDocuments}
                        loansDocuments={loansDocuments}
                        loanStatus={loanStatus}
                        status={status}
                    />
                </Grid>
            </Box>
        </Box>
    )
};

export default withPermissionHOC(LoanDetails, ['access_loan_details']);
